import { capitalizeFirstLetter } from "../stringFormatting";

const defaultType = 'save';
const types = {
    FILE: 'file',
    LINK: 'link',
    CREATE: 'create',
    DELETE: 'delete',
    UPLOAD: 'upload',
    DOWNLOAD: 'download',
    CLOSE: 'close',
    EDIT: 'edit',
    ADD: 'add',
    SEND: 'send',
    EMAIL: 'email',
    ACCEPT: 'accept',
    DECLINE: 'decline',
    REPLAY: 'replay',
    ADD_USERS: 'add_users',
    PLAY: 'play',
    ARCHIVE: 'archive',
    SEARCH: 'search',
    CHECK_ALL: 'check_all',
    COPY_ALL: 'copy_all',
    DONE_ALL: 'done_all',
    MAIL: 'mail',
    QUOTE: 'quote',
    ICONLESS: 'iconless',
    EVENT: 'event'
}

class CustomButton {
    constructor(type = '', text = '') {
        this.typeExists = true;
        this.type = '';
        this.text = '';
        this.icon = '';

        this.setCustomButtonType(type);
        this.setButtonText(text);
        this.setButtonIcon();
    }

    setCustomButtonType(type) {
        if (!type) return;

        if (!!types[type.toUpperCase()]) {
            this.type = type;
            return;
        }

        console.error(`Button type = ${type} not found, please add it to the list`)
        this.typeExists = false;
    }

    getType() {
        return this.type;
    }

    handleTypeDoesNotExist() {
        this.type = 'not-found-type'
        this.text = 'Undefined button type';
        this.icon = 'error';
    }

    setButtonText(text) {
        if (!this.typeExists) {
            this.handleTypeDoesNotExist();
            return;
        }

        if (text) {
            this.text = text;
            return;
        }

        switch(this.type) {
            case types.DELETE:
            case types.EDIT:
            case types.CREATE:
            case types.ADD:
            case types.SEND:
            case types.CLOSE:
            case types.ARCHIVE:
            case types.SEARCH:
            case types.COPY_ALL:
            case types.EVENT:
                this.text = capitalizeFirstLetter(this.type);
                break;
            case types.ADD_USERS:
                this.text = 'Add recipients';
                break;
            case types.PLAY:
                this.text = 'Continue';
                break;
            case types.ACCEPT:
                this.text = 'Yes';
                break;
            case types.DECLINE:
                this.text = 'No';
                break;
            default:
                this.text = capitalizeFirstLetter(defaultType);
                break;
        }
    }

    getText() {
        return this.text;
    }

    setButtonIcon() {
        if (!this.typeExists) {
            this.handleTypeDoesNotExist();
            return;
        }

        switch(this.type) {
            case types.CHECK_ALL:
                this.icon = 'library_add_check';
                break;
            case types.ADD_USERS:
                this.icon = 'person_add';
                break;
            case types.FILE:
                this.icon = 'insert_drive_file';
                break;
            case types.LINK:
                this.icon = 'open_in_new';
                break;
            case types.CREATE:
                this.icon = 'add';
                break;
            case types.PLAY:
                this.icon = 'play_arrow';
                break;
            case types.QUOTE:
                this.icon = 'format_quote';
                break;
            case types.DELETE:
            case types.UPLOAD:
            case types.DOWNLOAD:
            case types.CLOSE:
            case types.EDIT:
            case types.EMAIL:
            case types.ADD:
            case types.SEND:
            case types.ARCHIVE:
            case types.SEARCH:
            case types.COPY_ALL:
            case types.DONE_ALL:
            case types.REPLAY:
            case types.MAIL:
            case types.EVENT:
                this.icon = this.type;
                break;
            case types.DECLINE:
            case types.ACCEPT:
            case types.ICONLESS:
                this.icon = '';
                break;
            default:
                this.icon = 'check';
                break;
        }
    }

    getIcon(isLoading = false) {
        return isLoading ? 'autorenew' : this.icon;
    }
}

export default CustomButton;